import { Skeleton } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { Accordion } from 'src/components/era-package'
import { detailColumns, STATEMENT_TYPE } from '../../shared'
import { useDialogCache } from '../StatementDialogContext'
import { getSections } from './sectionMap'



export const StatementDetails = ({ type, loading, sectionData, parent = '', ...statement }) => {

  const sections = useMemo(() => getSections(type, statement.isFinalized), [type, statement])
  const [expanded, setExpanded] = useState(sections.map(s => s.key))
  const { fetchNewPage, currentPage } = useDialogCache()

  const toggleExpansion = key => {
    if (expanded.includes(key))
      setExpanded(expanded.filter(e => e !== key))
    else
      setExpanded([...expanded, key])
  }

  useEffect(() => {
    // reset section expansion when navigating to another page
    setExpanded(sections.map(s => s.key))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const handleRowClick = (row, [toOpenType, key]) => {
    let stmtNumber = row[key]
    if (toOpenType === STATEMENT_TYPE.entry)
      stmtNumber = [parent, row[key]]
    if(toOpenType === STATEMENT_TYPE.pmsDaily)
      stmtNumber = [row[key], statement.pmsNumber]
    fetchNewPage(stmtNumber, toOpenType, true, true)
  }

  return <>
    {sections.map((section, i) => <Accordion key={i}
      expanded={expanded.includes(section.key)}
      onChange={() => toggleExpansion(section.key)}
      title={section.title} icon={section.icon}
      DetailsProps={(section.key !== 'summaryTotal' && !loading)
        ? { sx: { p: 0 } } : {}
      }
    >
      {loading
        ? <Skeleton />
        : <section.Component
          type={type}
          final={statement.isFinalized || type === STATEMENT_TYPE.entry}
          data={sectionData[section.key]}
          columns={detailColumns[section.key]}
          {...!!section.rowAction && {
            onRowClick: row => handleRowClick(row, section.rowAction || [])
          }}
          TableProps={{ container: { sx: { py: 1 } } }}
        />
      }
    </Accordion>)}
  </>
}